import { Box, Button, Menu, MenuItem, Paper, Typography, useTheme } from '@mui/material'
import React, { useCallback, useEffect, useState } from 'react'
import CustomSearchBar from '../../components/common/CustomSearchBar'
import DataLoadingSpinner from '../../components/common/DataLoadingSpinner'
import { Link } from 'react-router-dom'
import { useUserStore } from '../../store/user.store'
import BreadcrumbList from '../../components/common/BreadcrumbList'
import { observer } from 'mobx-react'
import { ArrowDropDown } from '@mui/icons-material'
import TryAgainMessageBlock from '../../components/common/TryAgainMessageBlock'

const Subjects = observer( () => {

    const [filter, setFilter] = useState( 1 )
    const [filterOptions, setFilterOptions] = useState( [] )
    const [loading, setLoading] = useState( true )
    const [userRole, setUserRole] = useState( null )
    const [menuAnchor, setMenuAnchor] = useState( null )
    const [searchText, setSearchText] = useState( "" )

    const { palette, layout, shadows, border } = useTheme()
    const UserStore = useUserStore()


    const handleSubFilterChange = val => {
        setFilter( val )
        setMenuAnchor( null )
    }

    const subjectsFilterFunc = ( s ) => {
        if ( UserStore.getUser.user_role === 'STUDENT' ) {
            if ( UserStore.getUserSubjectsDetails.yearWise )
                return +s.current_year === +filter &&
                    ( s.subject_name?.toLowerCase()?.includes( searchText.toLowerCase() ) ||
                        s.subject_code?.toLowerCase()?.includes( searchText.toLowerCase() ) )
            else
                return +s.current_sem === +filter &&
                    ( s.subject_name?.toLowerCase()?.includes( searchText.toLowerCase() ) ||
                        s.subject_code?.toLowerCase()?.includes( searchText.toLowerCase() ) )
        } else {
            return s.ac_year === filter &&
                ( s.subject_name?.toLowerCase()?.includes( searchText.toLowerCase() ) ||
                    s.subject_code?.toLowerCase()?.includes( searchText.toLowerCase() ) )
        }
    }



    const getData = useCallback( async ( refresh = false ) => {
        setLoading( true )

        if ( UserStore.getErrorsStatuses?.subjects === true || refresh )
            await UserStore.fetchUserSubjects( refresh )
        try {
            setUserRole( UserStore.getUser.user_role )

            const subjectsDetails = UserStore.getUserSubjectsDetails
            if ( UserStore.getUser.user_role === 'STUDENT' ) {
                if ( subjectsDetails.yearWise ) {
                    setFilterOptions( subjectsDetails.years )
                    setFilter( subjectsDetails.years[0] )
                } else {
                    setFilterOptions( subjectsDetails.semesters )
                    setFilter( subjectsDetails.semesters[0] )
                }
            } else {
                setFilterOptions( subjectsDetails.academicYears )
                setFilter( subjectsDetails.academicYears[0] )
            }
        } catch ( err ) {
            console.log( err )
        } finally {
            setLoading( false )
        }
    }, [UserStore] )

    useEffect( () => {
        getData()
    }, [getData] )

    return (
        <Box padding={layout.pagePadding} display="flex" overflow="auto" flexDirection="column" flexGrow={1}>
            <BreadcrumbList items={["Courses", "All Subjects"]} />

            {/* <Paper sx={{
                flexGrow: !loading ? 1 : "initial",
                minHeight: "400px",
                overflow: "auto",
                display: "flex",
                flexDirection: "column",
                background: theme === 'dark' ? palette.common.bg : `linear-gradient(180deg, #FBF4E4 0%, #FFFFFF 100%)`
            }}> */}
            <Box display="flex" flexDirection="column" gap="10px">
                <Box position="relative"  >
                    <Typography variant="h1" fontWeight="600" component="h1" fontSize="16px">Your Subjects</Typography>
                    <Typography variant="subtitle2" fontSize="12px" color='textSecondary' >Manage your subjects.</Typography>
                </Box>
                <Box display="flex" flexWrap="wrap" gap="10px">
                    {UserStore.getErrorsStatuses?.subjects === false && filterOptions?.length > 0 && !loading && <Button onClick={e => setMenuAnchor( e.currentTarget )} disableElevation variant="contained" color="customThemeColor" sx={{ display: "flex", alignItems: "center", gap: "40px" }}  >
                        <Typography variant="subtitle2">{UserStore.getUser.user_role === "STUDENT" ? UserStore.getUserSubjectsDetails.yearWise ? "Year" : "Semester" : "Academic Year"} {filter}</Typography>
                        <ArrowDropDown />
                    </Button>}
                    <CustomSearchBar value={searchText} style={{ flexGrow: 1, fontSize: "14px" }} border={border[1]} placeholder='Search subjects...' onChange={e => setSearchText( e.target.value )} />

                    <Menu sx={{ marginTop: "5px" }} open={Boolean( menuAnchor )} anchorEl={menuAnchor} onClose={() => setMenuAnchor( null )} >
                        {filterOptions.map( ( sem, i ) => (
                            <MenuItem
                                onClick={() => handleSubFilterChange( sem )}
                                selected={sem === filter}
                                dense
                                sx={{ fontSize: "14px" }}
                                value={sem}
                                key={sem}
                            >{UserStore.getUser.user_role === "STUDENT" ? UserStore.getUserSubjectsDetails.yearWise ? "Year" : "Semester" : "Academic Year"} {sem}</MenuItem>
                        ) )}
                    </Menu>
                </Box>
                {!loading && UserStore.getErrorsStatuses?.subjects === false && UserStore.getUserSubjectsDetails.cached && <Box position="relative" fontSize="12px" sx={{ zIndex: 10 }} marginTop="-15px" color="white">
                    You are seeing cached data! <Typography sx={{ cursor: "pointer" }} onClick={() => getData( true )} fontSize="inherit" display="inline-block"><u><em><strong>Refresh Subjects</strong></em></u></Typography>
                </Box>}
            </Box>
            {loading && UserStore.getErrorsStatuses?.subjects === false && <DataLoadingSpinner waitingMessage="Loading subject please wait..." />}

            {!loading && UserStore.getErrorsStatuses?.subjects === false && <Box marginTop="20px" flexGrow={1} className="custom-scrollbar" overflow="auto">
                {UserStore.getUserSubjectsDetails.allSubjects && UserStore.getUserSubjectsDetails.allSubjects.length > 0 &&
                    <Box display="grid" overflow="hidden" gap="10px" gridTemplateColumns={{ lg: "repeat(3,1fr)", sm: "1fr 1fr", xs: "1fr" }} >
                        {UserStore.getUserSubjectsDetails.allSubjects
                            .filter( subjectsFilterFunc )
                            .map( ( sub ) => {
                                return (
                                    // <Link className='default-link' key={sub.subject_id} to={`/${UserStore.getUser?.user_role === "STUDENT" ? "student" : "faculty"}/subject/${sub.subject_code}/home`} >
                                    <Box
                                        key={sub.subject_id}
                                        overflow="hidden"
                                        gap='10px'
                                        boxShadow={shadows[1]}
                                        border={border[1]}
                                        padding='10px'
                                        display="flex"
                                        alignItems='center'
                                        bgcolor={sub.legacy_subject ? palette.error.light + "44" : palette.contentBg}
                                        borderRadius="5px"
                                    >
                                        <Typography padding="5px" borderRadius="5px" border={`1px solid #FF7039`} textTransform="uppercase" sx={{ minWidth: "50px", padding: "5px", textAlign: "center", wordBreak: "break-all", aspectRatio: 1, display: "flex", alignItems: "center", justifyContent: "center" }}>
                                            {sub.subject_name.split( " " ).map( c => c.length > 4 ? c[0] : "" ).join( "" )}
                                        </Typography>
                                        <Box minWidth="0" overflow="hidden">
                                            <Typography variant='subtitle2' textTransform="capitalize">{sub.subject_name} ({sub.subject_code})</Typography>
                                            <Typography color='textSecondary' fontSize="12px">{sub.subject_name_short}</Typography>
                                        </Box>
                                    </Box>
                                    // </Link>
                                )
                            } )}
                    </Box>

                }
                {userRole === "STUDENT" && UserStore.getUserSubjectsDetails?.allSubjects && UserStore.getUserSubjectsDetails.allSubjects.length === 0 && <Typography variant='subtitle2' margin="20px" borderRadius="5px" bgcolor={palette.warning.light} color={palette.warning.contrastText} textAlign="center" padding="20px">There are no subjects scheduled for this semester.</Typography>}
                {userRole !== "STUDENT" && UserStore.getUserSubjectsDetails?.allSubjects && UserStore.getUserSubjectsDetails.allSubjects.length === 0 && <Typography variant='subtitle2' margin="20px" borderRadius="5px" bgcolor={palette.warning.light} color={palette.warning.contrastText} textAlign="center" padding="20px">There are no subjects scheduled for this academic year.</Typography>}

                {UserStore.getUser.user_role !== 'STUDENT' && UserStore.getUserSubjectsDetails.allSubjects.filter( subjectsFilterFunc )?.length === 0 && <Typography padding="20px" bgcolor={palette.contentBg} borderRadius="10px" flexGrow={1} variant='subtitle2' display="flex" gap="10px" alignItems="center" justifyContent="center">
                    No subject matches the search text:   <strong><em>{searchText}</em></strong>
                </Typography>}

            </Box>
            }
            {!loading && UserStore.getErrorsStatuses?.subjects === true && <TryAgainMessageBlock loading={loading} styles={{ margin: "20px" }} parent='component' getData={() => getData()} />}
            {/* </Paper > */}
        </Box >
    )
} )

export default Subjects
